/**
 * Create store
 *
 * @since 2017-12-12
 * @author kdydesign.kim
 */

// Vuex Plugins
const Plugin = store => {
  store.subscribe(() => {})
}

export const plugins = [Plugin]

export const state = () => ({})

export const mutations = {}

export const actions = {}

export const getters = {}

export const strict = false
